export type GesStatusValue = number | string | null | undefined;

export interface GesStatusMeta {
  color: 'gray' | 'red' | 'orange' | 'green';
  hexColor: string;
}

const GES_STATUS_META: Record<number, GesStatusMeta> = {
  0: { color: 'gray', hexColor: '#868E96' },
  1: { color: 'red', hexColor: '#FA5252' },
  2: { color: 'orange', hexColor: '#FD7E14' },
  3: { color: 'green', hexColor: '#40C057' },
};

export function getGesStatusI18nKey(status: number): string {
  return `sampling.results.stats.ges_${status}`;
}

export function parseGesStatus(value: GesStatusValue): number | undefined {
  const parsed = typeof value === 'string' ? Number(value) : value;
  return Number.isInteger(parsed) ? Number(parsed) : undefined;
}

export function getGesStatusMeta(value: GesStatusValue): GesStatusMeta | null {
  const status = parseGesStatus(value);
  if (status == null) return null;
  return GES_STATUS_META[status] ?? null;
}

export function getGesStatusCssColor(
  value: GesStatusValue,
  shade = 6,
): string | null {
  const meta = getGesStatusMeta(value);
  if (!meta) return null;
  return `var(--mantine-color-${meta.color}-${shade})`;
}

export function getGesStatusHexColor(value: GesStatusValue): string | null {
  const meta = getGesStatusMeta(value);
  if (!meta) return null;
  return meta.hexColor;
}
